var map = {
	"./exit.svg": "e053",
	"./man.svg": "f3c0",
	"./menu1.svg": "8694",
	"./menu2.svg": "b9dd",
	"./menu3.svg": "7048",
	"./menu4.svg": "6da7",
	"./menu5.svg": "aa8e",
	"./menu6.svg": "3ee8",
	"./menua1.svg": "b045",
	"./menua10.svg": "648f",
	"./menua11.svg": "b389",
	"./menua12.svg": "f49a",
	"./menua13.svg": "1961",
	"./menua14.svg": "07b3",
	"./menua15.svg": "3917",
	"./menua16.svg": "a6ea",
	"./menua2.svg": "f907",
	"./menua3.svg": "7ddd",
	"./menua4.svg": "7a5c",
	"./menua5.svg": "3cc3",
	"./menua6.svg": "3ba4",
	"./menua7.svg": "4795",
	"./menua8.svg": "2292",
	"./menua9.svg": "8c98",
	"./psw.svg": "29fd",
	"./smile.svg": "47a6",
	"./tel.svg": "9bae",
	"./warn.svg": "1f09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a71";